<template>
  <component
    v-if="component_data.component"
    :is="component_data.component"
    :component_data="component_data"
    v-on="$listeners"
  ></component>
</template>

<script>
import tabbedSection from "../TabbedSection/tabbedSection.vue";
import function_obertabs from "../TabbedSection/uberTabbedSection.vue";
import tabContents from "../TabbedSection/tabContents.vue";
import LpHeader from "../LpHeader/LpHeader.vue";
import Featured_tx_left from "../LpSections/Featured_tx_left.vue";
import Featured_tx_right from "../LpSections/Featured_tx_right.vue";
import RecommendedProducts from "@/components/RecommendedProducts/RecommendedProducts";
import GroupedRecommendedProducts from "@/components/RecommendedProducts/GroupedRecommendedProducts";
import CustomSection03 from "@/components/LpSections/CustomSection03";
import CustomSection04 from "@/components/LpSections/CustomSection04";
import CustomSection05 from "@/components/LpSections/CustomSection05";
import CustomSection06 from "@/components/LpSections/CustomSection06";
import instructions from "@/components/LpSections/instructions";
import FeaturesPanel from "@/components/LpSections/FeaturesPanel";
import PinsSection from "@/components/LpSections/PinsSection";
import RefrigeratorsCustom01 from "@/components/LpSections/Refrigerators_custom_01";
import RefrigeratorsCustom02 from "@/components/LpSections/Refrigerators_custom_02";
import slides from "@/components/autoSlides/autoSlides";
import OvensSlidePins from "@/components/LpSections/Ovens_slide_pins";
import xtypeHeader from "../LpHeader/xtypeHeader.vue";
import xtypeSectionHeader from "@/components/LpSections/xtypeSectionHeader";
import xtype_internal_nav from "@/components/LpSections/xtype_internal_nav";
import sidelink from "@/components/LpSections/sidelink";
// import BuyonlineSideWidget from "@/components/BuyonlineSideWidget/BuyonlineSideWidget"; 
import SteamTouchDress from "@/components/LpSections/SteamTouchDress";
import SplitSection from "@/components/LpSections/SplitSection";
import FourWidgetsSection from "@/components/LpSections/FourWidgetsSection";

// lodówki 2020
import RefrigeratorsWrapper from "../Refrigerators2020/MainWrapper";

// Zaprojektowane po ludzku
import PoLudzku from "@/components/LandingPages/zpl/main";

// Agregat filmów z Gregorym
import videoAggregator from "@/components/LandingPages/videoAggregator/main";

//buttonBuyOnline na LP
import "swiper/css/swiper.css";

import SliderBuyOnline from "@/components/SliderBuyOnline2020/SliderBuyOnlineMain";

export default {
  props: ["component_data"],
  data() {
    return {
      exist: false
    };
  },
  // template
  beforeMount() {
    if (this.$options.components[this.component_data.component]) {
      this.exist = true;
    } else {
      this.exist = false;
    }
  },
  beforeUpdate() {
    if (this.$options.components[this.component_data.component]) {
      this.exist = true;
    } else {
      this.exist = false;
    }
  },
  components: {
    LpHeader: LpHeader,
    Featured_tx_left: Featured_tx_left,
    Featured_tx_right: Featured_tx_right,
    function_obertabs: function_obertabs,
    function_tabs: tabbedSection,
    text_right: tabContents,
    text_left: tabContents,
    text_right_vid: tabContents,
    text_right_vid_no_thumb: tabContents,
    text_left_vid: tabContents,
    text_left_vid_no_thumb: tabContents,
    text_right_video_left: tabContents,
    RecommendedProducts: RecommendedProducts,
    CustomSection03: CustomSection03,
    CustomSection04: CustomSection04,
    CustomSection05: CustomSection05,
    CustomSection06: CustomSection06,
    RefrigeratorsCustom01: RefrigeratorsCustom01,
    RefrigeratorsCustom02: RefrigeratorsCustom02,
    slides: slides,
    OvensSlidePins: OvensSlidePins,
    FeaturesPanel: FeaturesPanel,
    xtypeHeader: xtypeHeader,
    xtypeSectionHeader: xtypeSectionHeader,
    GroupedRecommendedProducts: GroupedRecommendedProducts,
    xtype_internal_nav: xtype_internal_nav,
    // BuyonlineSideWidget: BuyonlineSideWidget,
    sidelink: sidelink,
    PoLudzku: PoLudzku,
    videoAggregator: videoAggregator,
    instructions: instructions,
    PinsSection: PinsSection,
    RefrigeratorsWrapper: RefrigeratorsWrapper,
    SteamTouchDress: SteamTouchDress,
    SplitSection: SplitSection,
    SliderBuyOnline: SliderBuyOnline,
    FourWidgetsSection: FourWidgetsSection
  }
};
</script>
